import React, { useState, useEffect } from "react";
import "./App.css";
import PlayerHand from "./components/playerHand";
import DealerHand from "./components/dealerHand";
import BetManager from "./components/betManager";
import AdBanner from "./components/adBanner";


function App() {
  const [remainingCards, setRemainingCards] = useState(() => {
    const savedCards = localStorage.getItem("remainingCards");
    return savedCards ? JSON.parse(savedCards) : [];
  });
  
  const [stand, setStand] = useState(false);
  const [playerScore, setPlayerScore] = useState(0);
  const [dealerScore, setDealerScore] = useState(0);
  const [dealerPossibleBlackJack, setDealerPossibleBlackJack] = useState(false);
  const [dealerBlackJack, setDealerBlackJack] = useState(false);
  const [playerBlackJack, setPlayerBlackJack] = useState(false);
  const [resultMessage, setResultMessage] = useState("");
  const [resultWins, setResultWins] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [playerScoreSplit1, setPlayerScoreSplit1] = useState(0);
  const [playerScoreSplit2, setPlayerScoreSplit2] = useState(0);
  const [blackJackSplit1, setBlackJackSplit1] = useState(false);
  const [blackJackSplit2, setBlackJackSplit2] = useState(false);
  const [hasBet, setHasBet] = useState(false); 
  const [bet, setBet] = useState(() => {
    const savedBet = localStorage.getItem("bet");
    return savedBet ? savedBet : "";
  });
  const [balance, setBalance] = useState(() => {
      const savedBalance = localStorage.getItem("balance");
      return savedBalance ? Number(savedBalance) : 1000;
    });

  console.log("playerScoreSplit1:" + playerScoreSplit1);
  console.log("playerScoreSplit2:" + playerScoreSplit2);

  useEffect(() => {
    if (bet !== "") {
      localStorage.setItem("bet", bet);
    }
  }, [bet]);

  
  useEffect(() => {
    if (hasBet) {
      iniciarPartida(); // Solo inicia si ya apostó
    }
  }, [hasBet]);

  const iniciarPartida = () => {
    const cards = [
      "A♦", "2♦", "3♦", "4♦", "5♦", "6♦", "7♦", "8♦", "9♦", "10♦", "J♦", "Q♦", "K♦",
      "A♥", "2♥", "3♥", "4♥", "5♥", "6♥", "7♥", "8♥", "9♥", "10♥", "J♥", "Q♥", "K♥",
      "A♠", "2♠", "3♠", "4♠", "5♠", "6♠", "7♠", "8♠", "9♠", "10♠", "J♠", "Q♠", "K♠",
      "A♣", "2♣", "3♣", "4♣", "5♣", "6♣", "7♣", "8♣", "9♣", "10♣", "J♣", "Q♣", "K♣"
    ];
    const shuffled = cards.sort(() => Math.random() - 0.5);
    setRemainingCards(shuffled);
    localStorage.setItem("remainingCards", JSON.stringify(shuffled));
  };
  

  const handleRefresh = () => {
    setHasBet(false); 
    setResultMessage(""); 
    setResultWins(0); 
    localStorage.removeItem("remainingCards");
    localStorage.removeItem("bet");
    localStorage.removeItem("hasBet");
    localStorage.removeItem("dealerCards");
    localStorage.removeItem("betLocked")
    window.location.reload();
  };


  useEffect(() => {
    if (dealerScore > 16) {
      compareScores();
    } else if (playerScore > 21) {
      compareScores();
    } else if (playerScoreSplit1 > 21 && playerScoreSplit2 > 21) {
      compareScores();
    } else if (
      (playerBlackJack || (blackJackSplit1 && blackJackSplit2)) &&
      !dealerPossibleBlackJack
    ) {
      compareScores();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dealerScore, playerScore, playerScoreSplit1, playerScoreSplit2]);

  const compareScores = () => {
    let message = "";
    let wins = "";
// SI NO HAY SPLIT
    if (playerScoreSplit1 === 0) {
// el jugador se pasa de 21
      if (playerScore > 21) {
        message = "El crupier gana, te pasastes de 21.";
        wins = -1
// el dealer se pasa de 21
      } else if (dealerScore > 21) {
        message = "Ganas la partida, el crupier se pasó de 21.";
        wins = 1
// Jugador y dealer tienen blackjack
      } else if (playerBlackJack && dealerBlackJack) {
        message = "¡Ambos teneis Black Jack! Empate, nadie gana.";
        wins = 0
// el jugador tiene blackjack y el dealer no
      } else if (playerBlackJack && !dealerBlackJack) {
        message = "¡Blackjack! Ganas la partida";
        wins = 1
// el dealer tiene blackjack y el jugador no
      } else if (!playerBlackJack && dealerBlackJack) {
        message = "Blackjack del crupier. Pierdes la partida";
        wins = -1
// empate
      } else if (playerScore === dealerScore) {
        message = "Empate, nadie gana.";
        wins = 0
// no hay blackjack y el jugador tiene mas puntos
      } else if (playerScore > dealerScore && !playerBlackJack) {
        message = "Ganas la partida, tienes un puntaje mayor que el crupier.";
        wins = 1
// Para todo lo demas el crupier gana
      } else {
        message = "El crupier gana, tiene un puntaje mayor que tú.";
        wins = -1
      }
// SI HAY SPLIT
    } else {
// El jugador se pasa de 21 en las 2 manos
      if (playerScoreSplit1 > 21 && playerScoreSplit2 > 21) {
        message = "El crupier gana, te pasastes de 21 en ambas manos.";
        wins = -2
// El jugador se pasa de 21 en 1 mano y el crupier tambien se pasa de 21
      } else if (
        (playerScoreSplit1 > 21 &&
          playerScoreSplit2 <= 21 &&
          dealerScore > 21) ||
        (playerScoreSplit1 <= 21 && playerScoreSplit2 > 21 && dealerScore > 21)
      ) {
        message =
          "Ganas una de tus manos porqué el crupier se pasó de 21, pero pierdes la otra al pasarte de 21.";
          wins=0
// El jugador se pasa de 21 en una mano y pierde la otra por puntos
        } else if (
        (playerScoreSplit1 > 21 &&
          playerScoreSplit2 <= 21 &&
          dealerScore > playerScoreSplit2) ||
        (playerScoreSplit1 <= 21 &&
          playerScoreSplit2 > 21 &&
          dealerScore > playerScoreSplit1)
      ) {
        message =
          "Pierdes tus dos manos, una por puntos y la otra al pasarte de 21.";
          wins = -2
// El jugador se pasa de 21 en una y empata la otra mano
      } else if (
        (playerScoreSplit1 > 21 &&
          playerScoreSplit2 <= 21 &&
          dealerScore === playerScoreSplit2) ||
        (playerScoreSplit2 > 21 &&
          playerScoreSplit1 <= 21 &&
          dealerScore === playerScoreSplit1)
      ) {
        message =
          "Pierdes una de tus manos al pasarte de 21, empatas la otra por puntos.";
          wins = -1
// El jugador no se pasa de 21 en ninguna pero el dealer si
      } else if (
        playerScoreSplit1 <= 21 &&
        playerScoreSplit2 <= 21 &&
        dealerScore > 21
      ) {
        message = "Ganas tus dos manos, el crupier se pasó de 21.";
        wins = 2
// las dos manos del jugador y la mano del dealer todas con blackjack
      } else if (blackJackSplit1 && blackJackSplit2 && dealerBlackJack) {
        message = "Empatas tus dos manos con BlackJack, nadie gana.";
        wins = 0
// Las dos manos del jugador tienen blackjack peor el dealer no
      } else if (blackJackSplit1 && blackJackSplit2 && !dealerBlackJack) {
        message = "¡Doble Blackjack! Ganas la partida";
        wins = 2
// El jugador empata una mano con blackjack y pierde la otra
      } else if (
        (blackJackSplit1 && !blackJackSplit2 && dealerBlackJack) ||
        (!blackJackSplit1 && blackJackSplit2 && dealerBlackJack)
      ) {
        message =
          "Empatas unas de tus manos con Black Jack, pierdes la otra mano.";
          wins = -1
// Si una mano del jugador es black jack pero la otra mano y el dealer no,
      } else if (
        (blackJackSplit1 && !blackJackSplit2 && !dealerBlackJack) ||
        (!blackJackSplit1 && blackJackSplit2 && !dealerBlackJack)
      ) {
// El jugador gana las dos manos, una con blackjack la otra no
        if (
          (playerScoreSplit1 > dealerScore &&
            blackJackSplit1 &&
            playerScoreSplit2 > dealerScore &&
            !blackJackSplit2) ||
          (playerScoreSplit2 > dealerScore &&
            blackJackSplit2 &&
            playerScoreSplit1 > dealerScore &&
            !blackJackSplit1)
        ) {
          message =
            "¡Una de tus manos es Blackjack! Has ganado también la otra mano";
            wins = 2
// El jugador gana una mano con blackjack y la otra la pierde por puntos
        } else if (
          (playerScoreSplit1 > dealerScore &&
            blackJackSplit1 &&
            playerScoreSplit2 < dealerScore &&
            !blackJackSplit2) ||
          (playerScoreSplit2 > dealerScore &&
            blackJackSplit2 &&
            playerScoreSplit1 < dealerScore &&
            !blackJackSplit1)
        ) {
          message =
            "¡Ganas una de tus manos con Blackjack! Has perdido la otra mano";
            wins = 0
// El jugador gana una mano con blackjack y la otra la empata
        } else if(
          (playerScoreSplit1 > dealerScore &&
            blackJackSplit1 &&
            playerScoreSplit2 === dealerScore &&
            !blackJackSplit2) ||
          (playerScoreSplit2 > dealerScore &&
            blackJackSplit2 &&
            playerScoreSplit1 === dealerScore &&
            !blackJackSplit1)
        ){
          message =
            "¡Ganas una de tus manos con Blackjack! Has empatado la otra mano";
            wins = 1
        }
// Salimos del bucle de una mano con blackjack
// El dealer tiene blackjack y el jugador no
      } else if (!blackJackSplit1 && !blackJackSplit2 && dealerBlackJack) {
        message = "Blackjack del crupier. Pierdes tus dos manos";
        wins = -2
// El jugador se pasa de 21 en una y supera al dealer en la otra
      } else if (
        (playerScoreSplit1 > 21 &&
          playerScoreSplit2 <= 21 &&
          dealerScore < playerScoreSplit2) ||
        (playerScoreSplit1 <= 21 &&
          playerScoreSplit2 > 21 &&
          dealerScore < playerScoreSplit1)
      ) {
        message =
          "Ganas una de tus manos por puntos y la otra la pierdes al pasarte de 21."
          wins = 0
// El jugador empata las dos manos
      } else if (
        playerScoreSplit1 === dealerScore &&
        playerScoreSplit2 === dealerScore
      ) {
        message = "Empate, nadie gana.";
        wins = 0
// El jugador empata una mano y pierde la otra
      } else if (
        (playerScoreSplit1 < dealerScore &&
          playerScoreSplit2 === dealerScore) ||
        (playerScoreSplit1 === dealerScore && playerScoreSplit2 < dealerScore)
      ) {
        message = "Empatas una de tus manos, pierdes la otra.";
        wins = -1
// EL jugador gana una mano y empata la otra
      } else if (
        (playerScoreSplit1 > dealerScore &&
          playerScoreSplit2 === dealerScore) ||
        (playerScoreSplit1 === dealerScore && playerScoreSplit2 > dealerScore)
      ) {
        message = "Ganas una de tus manos, empatas la otra.";
        wins = 1
// EL jugador gana con doble blackjack
      } else if (
        playerScoreSplit1 > dealerScore &&
        blackJackSplit1 &&
        playerScoreSplit2 > dealerScore &&
        blackJackSplit2
      ) {
        message = "¡Doble Blackjack! Ganas la partida";
        wins = 2
// El jugador gana las dos manos por puntos
      } else if (
        playerScoreSplit1 > dealerScore &&
        playerScoreSplit2 > dealerScore
      ) {
        message =
          "El jugador gana las dos manos, tiene los dos puntajes mayores que el crupier.";
          wins = 2
// El jugador gana una mano y pierde la otra
      } else if (
        (playerScoreSplit1 < dealerScore && playerScoreSplit2 > dealerScore) ||
        (playerScoreSplit1 > dealerScore && playerScoreSplit2 < dealerScore)
      ) {
        message =
          "El jugador gana una de las manos pero pierde la otra en comparación de puntajes.";
          wins = 0
// Para todo lo demas el crupier gana por puntos las dos manos
      } else {
        message =
          "El crupier gana, tiene un puntaje mayor que el jugador en ambas manos.";
          wins = -2
      }
    }
    setResultMessage(message);
    setResultWins(wins);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };



  
  return (
    <div className="App">
      {showModal && (
        <div className="modal">
          <div className="modal-content text-center">
            {/* <span className="close" onClick={closeModal}>
              &times;
            </span> */}
            <h5>{resultMessage}</h5>
            <button className="btn btn-dark mt-3" onClick={handleRefresh}>
              Volver a jugar
            </button>
          </div>
        </div>
      )}

      <DealerHand
        remainingCards={remainingCards}
        setRemainingCards={setRemainingCards}
        stand={stand}
        setStand={setStand}
        dealerScore={dealerScore} 
        setDealerScore={setDealerScore}
        dealerPossibleBlackJack={dealerPossibleBlackJack}
        setDealerPossibleBlackJack={setDealerPossibleBlackJack}
        setDealerBlackJack={setDealerBlackJack}
        playerBlackJack={playerBlackJack}
        blackJackSplit1={blackJackSplit1}
        blackJackSplit2={blackJackSplit2}
      />
   
      <PlayerHand
        remainingCards={remainingCards}
        setRemainingCards={setRemainingCards}
        stand={stand}
        playerScore={playerScore}
        setPlayerScore={setPlayerScore}
        playerBlackJack={playerBlackJack}
        setPlayerBlackJack={setPlayerBlackJack}
        setPlayerScoreSplit1={setPlayerScoreSplit1}
        setPlayerScoreSplit2={setPlayerScoreSplit2}
        blackJackSplit1={blackJackSplit1}
        setBlackJackSplit1={setBlackJackSplit1}
        blackJackSplit2={blackJackSplit2}
        setBlackJackSplit2={setBlackJackSplit2}
        balance={balance}
        bet={bet}
        setBalance={setBalance}
      />
      { playerScoreSplit1 > 0 ? (
              <div className="d-flex justify-content-center">
                <div classname="d-flex flex-column ">
                <h5>Una de tus manos: {playerScoreSplit1} </h5>
                <h5>La otra mano: {playerScoreSplit2} </h5>
                </div>
              </div>
            ): playerScore > 0 ?(
            <div className="d-flex justify-content-center">
                <h5>Puntos: {playerScore} </h5>
            </div>
          ):(
            <></>
          )}
      <BetManager 
      resultMessage={resultMessage}
      resultWins={resultWins} 
      onBetPlaced={() => setHasBet(true)}
      bet={bet}
      setBet={setBet}
      balance={balance}
      setBalance={setBalance}
      showModal={showModal}
      />

      <AdBanner/>
      <div className="d-flex justify-content-center">
      
      <a className="no-link" target="_blank" rel="noopener noreferrer" href="https://peremartinezibar.com" >Desarrollado por: Pere Martínez Ibar</a>
    </div>
    </div>
    
  );
}

export default App;
